import React, { createRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '0 auto',

  },
  appBar: {
    backgroundColor: 'transparent',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row-reverse',
    padding: '2rem',
    boxShadow: "0px 0px 0px transparent",
  },
  menuButton: {
    // padding: '8px 16px',
    border: '3px  solid',
    borderRadius: '8%',
    color: 'black',
    width: '5rem',
    height: '5rem',
    padding: '0 1.1rem',
    alignSelf: 'center',
    opacity: '60%',
  },

}));

export default function ButtonAppBar({ siteTitle }) {
  const classes = useStyles();


  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar position="fixed" className={classes.noMargin}>
          <MenuIcon className={classes.menuButton} fontSize='large' />
        </Toolbar>
      </AppBar>
    </div>
  );
}